import { Button } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { denyVipContent, disableVipContent, requestVipContent } from '../../../../../../../redux/actions/users'
import { IRootState } from '../../../../../../../redux/types'
import { IBrand, ILine, VIP } from '../../../../models/user'
import { isCommercialOrClientOrTrainer, isManager } from '../../../../utils/RolesHelper'

interface VipActionsProps {
  data: IBrand | ILine
  typeData: string
}

export function VipActions({ data, typeData }: VipActionsProps) {
  const { t } = useTranslation(['global'])
  const dispatch = useDispatch()

  const { user: authUser } = useSelector((state: IRootState) => state.auth)
  const { userProfileSelected } = useSelector((state: IRootState) => state.user)

  const { vipStatus, id } = data
  if (vipStatus === undefined || vipStatus === null) return <></>

  const handleRequestVip = (id: number, type: string) => {
    dispatch(requestVipContent({ id, type, user_id: userProfileSelected.id }))
  }

  const handleDenyVip = (id: number, type: string) => {
    dispatch(denyVipContent({ id, type, user_id: userProfileSelected.id }))
  }

  const handleDisableVipContent = (id: number, type: string) => {
    dispatch(disableVipContent({ id, type, user_id: userProfileSelected.id }))
  }

  return (
    <>
      {vipStatus === VIP.Inactive && isCommercialOrClientOrTrainer(userProfileSelected.role_id) && !isManager(authUser.role_id) && (
        <Button
          size="small"
          style={{ margin: '10px 0px' }}
          id="btn-request-vip"
          variant="contained"
          color="primary"
          onClick={() => handleRequestVip(id, typeData)}
        >
          {t('admin.people.request-vip')}
        </Button>
      )}

      {vipStatus === VIP.Pending && userProfileSelected.id !== authUser.id && !isCommercialOrClientOrTrainer(authUser.role_id) && (
        <Button
          sx={{ mr: 1 }}
          size="small"
          style={{ margin: '10px 0px' }}
          id="btn-deny-vip"
          variant="text"
          color="secondary"
          onClick={() => handleDenyVip(id, typeData)}
        >
          {t('admin.people.deny-vip')}
        </Button>
      )}

      {vipStatus === VIP.Active && userProfileSelected.id !== authUser.id && (
        <Button
          size="small"
          onClick={() => handleDisableVipContent(id, typeData)}
          component="label"
          variant="text"
          color="secondary"
          tabIndex={-1}
        >
          {t('cancel')}
        </Button>
      )}
    </>
  )
}
